<template>
  <transition name="page" mode="out-in">
    
    <div id="wrapper">
      <Leftbar v-if="loggedIn"></Leftbar>
      <div id="page-content-wrapper">
        <Navbar v-if="showNavbar"></Navbar>
        <div id="page-content">
          <router-view></router-view>
          <Footer></Footer>
        </div>
      </div>
      <div class="overlay" :class="{'toggled': showSidebar}" v-on:click="hideAll"></div>
    </div>

    
  </transition>
</template>
<script>
import Navbar from "@/components/Layout/Navbar";
import Leftbar from "@/components/Layout/Leftbar";
import Footer from "@/components/Layout/Footer";
export default {
  components: { Leftbar, Navbar, Footer },
  data() {
    return {};
  },
  methods: {
    hideAll() {
      this.$store.dispatch("sidebar/hideAll");
    }
  },
  computed: {
    showSidebar() {
      return this.$store.state.sidebar.leftbar;
    },
    showNavbar() {
      if(this.$store.state.auth.user)
      {
        return true;
      }else{
        if(this.$route.meta.public == true)
        {
          return true;
        }
      }
      return false;
    },
    loggedIn() {
      return this.$store.state.auth.user;
    }
  }
};
</script>